import React, { useContext, useEffect, memo } from "react";
import { withRouter } from "react-router-dom";
// import Spinner from "../../Spinner/Spinner";

import Row from "./Row";
import Cargando from "../../../../components/Extra/Cargando";

import TablaCabecera from "../../../../components/Extra/TablaCabecera";

import AuthContext from "../../../../Context/Auth/AuthContext";
// MATERIAL
import { makeStyles } from "@mui/styles";
import {
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableCell,
  Typography,
  TableRow,
} from "@mui/material";
import ToolBarTable from "./ToolBarTable";
const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 450,
  },
  celda: {
    fontSize: ".7rem !important",
  },
});
const Tabla = (props) => {
  const {
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    setopen,
    rows,
    seteditar,
    search,
    input,
    orden,
    setinput,
    setorden,
    cargando,
    setcargando,
    fullBuscador,
    estadoRequest,
    // STATE
    addRowsState,
    getDataState,
    remplazarRowsState,
    obtenerState,
    pagination,
    columns,
    // ObjectoActivo,
    changeObjetoActivoState,
    // rowsImportState,
    // export
    arrayExport,
    setarrayExport,
    campoExport,
    socket,
  } = props;

  const {
    usuario: { rucempresa },
  } = useContext(AuthContext);
  //columnas y rows de la tabla

  // eslint-disable-next-line
  const clases = useStyles();
  // eslint-disable-next-line

  // eslint-disable-next-line
  // eslint-disable-next-line
  // eslint-disable-next-line

  //clases
  const classes = useStyles();
  const reducer = (previousValue, currentValue) =>
    Number(previousValue) + Number(currentValue);

  const handleChangePage = async (event, newPage) => {
    if (newPage * rowsPerPage + rowsPerPage > rows.length) {
      setcargando(true);
      const res = await getDataState(
        rowsPerPage,
        newPage,
        search,
        input.id,
        orden,
        JSON.stringify(fullBuscador),
        rucempresa,
        estadoRequest
      );

      const data = res.data.data.results;
      setcargando(false);
      const resultado = data.filter((row) => {
        const existe = rows.some((item, index) => {
          return row.fechaFactura === item.fechaFactura;
        });

        return !existe;
      });

      addRowsState(resultado);
    }

    setPage(newPage);
  };

  // eslint-disable-next-line

  const handleChangeRowsPerPage = async (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    if (page === 0) {
      if (event.target.value > rows.length) {
        setcargando(true);
        await obtenerState(
          event.target.value,
          0,
          search,
          input.id,
          orden,
          JSON.stringify(fullBuscador),
          rucempresa,
          estadoRequest
        );
        setcargando(false);
      }
    }
  };

  const funcionOrdenar = async (column) => {
    setcargando(true);
    await remplazarRowsState(
      rowsPerPage,
      0,
      search,
      column.id,
      !orden,
      JSON.stringify(fullBuscador),
      rucempresa,
      estadoRequest
    );
    setPage(0);
    setinput(column);
    setorden(!orden);
    setcargando(false);
  };
  const funcionReload = async () => {
    setcargando(true);
    setRowsPerPage(10);
    setPage(0);
    await obtenerState(
      10,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      rucempresa,
      estadoRequest
    );
    setcargando(false);
  };
  useEffect(() => {
    //eslint-disable-next-line

    obtenerState(
      10,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      rucempresa,
      estadoRequest
    );

    // eslint-disable-next-line
  }, []);
  //si no hay usuarios //rows no cargar el componente
  if (!rows) {
    return <Cargando titulo="Cargando" />;
  }
  if (!pagination) {
    return <Cargando titulo="Cargando pagination" />;
  }

  return (
    <Paper className={classes.root}>
      <ToolBarTable
        search={search}
        titulo={`Compras: ${estadoRequest}`}
        arrayExport={arrayExport}
        columns={columns}
        expandible={false}
        campoExport={campoExport}
        tabla="compra"
        funcionReload={funcionReload}
        pagination={pagination}
        rowsPerPage={rowsPerPage}
        rows={rows}
        page={page}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        socket={socket}
        fullBuscador={fullBuscador}
        estadoRequest={estadoRequest}
      />
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table" id="tabla" size="small">
          {" "}
          {/* <caption
            style={{
              padding: "0px",
              paddingRight: "1rem",
              paddingLeft: "1rem",
            }}
          >
            <Box
              width={"100%"}
              p={1}
              display={"flex"}
              justifyContent={"flex-end"}
            ></Box>
          </caption> */}
          {/* <ModalCarnet setopen={setopen} onChangeCarnetActivo={onChangeCarnetActivo}/> */}
          <TableHead>
            <TablaCabecera
              remplazarRowsState={remplazarRowsState}
              search={search}
              input={input}
              setinput={setinput}
              orden={orden}
              setorden={setorden}
              rowsPerPage={rowsPerPage}
              page={page}
              setPage={setPage}
              setcargando={setcargando}
              rows={rows}
              setarrayExport={setarrayExport}
              columns={columns}
              habilitarOrdenar={true}
              funcionOrdenar={funcionOrdenar}
            />
          </TableHead>
          <TableBody>
            {cargando ? (
              <TableCell
                size="small"
                align="center"
                colSpan={columns.length + 2}
              >
                <Cargando titulo="Cargando Datos" />
              </TableCell>
            ) : (
              rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                    <Row
                      campoExport={campoExport}
                      rows={rows}
                      seteditar={seteditar}
                      arrayExport={arrayExport}
                      setarrayExport={setarrayExport}
                      row={row}
                      index={index}
                      setopen={setopen}
                      key={row.compId}
                      changeObjetoActivoState={changeObjetoActivoState}
                      socket={socket}
                    />
                  );
                })
            )}
            <TableRow>
              <TableCell
                padding="none"
                size="small"
                align="center"
                className={classes.celda}
              ></TableCell>
              <TableCell
                padding="none"
                size="small"
                align="center"
                className={classes.celda}
              ></TableCell>
              <TableCell
                padding="none"
                size="small"
                align="center"
                className={classes.celda}
              ></TableCell>
              <TableCell
                padding="none"
                size="small"
                align="center"
                className={classes.celda}
              ></TableCell>
              <TableCell
                padding="none"
                size="small"
                align="center"
                className={classes.celda}
              ></TableCell>
              <TableCell
                padding="none"
                size="small"
                align="center"
                className={classes.celda}
              >
                <Typography
                  variant="body2"
                  color="primary"
                  style={{ paddingRight: ".5rem", fontWeight: "bold" }}
                >
                  $
                  {rows.length === 0
                    ? null
                    : rows
                        .map((row) => {
                          return Number(row.valTotalRetencion);
                        })
                        .reduce(reducer)
                        .toFixed(2)}
                </Typography>
              </TableCell>
              <TableCell
                padding="none"
                size="small"
                align="center"
                className={classes.celda}
              ></TableCell>
              <TableCell
                padding="none"
                size="small"
                align="center"
                className={classes.celda}
              ></TableCell>
              <TableCell
                padding="none"
                size="small"
                align="center"
                className={classes.celda}
              ></TableCell>
              <TableCell
                padding="none"
                size="small"
                align="center"
                className={classes.celda}
              >
                <Typography
                  variant="body2"
                  color="primary"
                  style={{ fontWeight: "bold" }}
                >
                  $
                  {rows.length === 0
                    ? null
                    : rows
                        .map((row) => {
                          return Number(row.valorFactura);
                        })
                        .reduce(reducer)
                        .toFixed(2)}
                </Typography>{" "}
              </TableCell>{" "}
              <TableCell
                padding="none"
                size="small"
                align="center"
                className={classes.celda}
              ></TableCell>{" "}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
export default memo(withRouter(Tabla));
